import styledBase, { createGlobalStyle as createGlobalStyleBase, css as cssBase, ThemeProvider as ThemeProviderPass, useTheme, withTheme as withThemeBase, } from "styled-components";
export const styled = styledBase;
export const css = cssBase;
export const withTheme = withThemeBase;
export const useThemeBase = useTheme;
export const ThemeProviderBase = ThemeProviderPass;
export const createGlobalStyle = createGlobalStyleBase;
